/**
 * Utility functions for UnitConfigurationEditor
 */

/**
 * Disable slash key input for text fields
 */
export const disableSlashKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const disabledKeys = ['/'];
  if (disabledKeys.includes(event.key)) {
    event.preventDefault();
  }
};

/**
 * Styling constants and helper functions
 */
export const getEditorStyles = () => ({
  container: {
    padding: 3,
    marginTop: 2
  },
  contentWrapper: {
    width: '100%',
    maxWidth: '98%',
    mx: 'auto',
    overflowX: 'visible', 
    overflowY: 'visible'
  }
}); 